// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6bb6cd0e","236":"1c3dd15b","345":"d1c03b8c","397":"06259d7e","453":"bb269180","455":"7a340c8a","488":"b01e21ca","814":"f8eaf8e4","977":"3a6bc354"}[chunkId] + ".chunk.js";
};